<template>
<div class="service-content">
  <div class="content">
    <div class="title-name">行业解决方案</div>
    <div class="title-sub">
      橡诺科技有限公司经过多年对客户的经验总结，通过不断的积累，创新，为客户提供各个行业全终端的互联网解决方案。面向全体用户，想客户之所想，做客户之想做
    </div>
    <div class="list">
      <router-link class="item" to="/solutionDetails1" target="_blank">
        <div class="pic"><img src="@/assets/img/solution/1.jpg"></div>
        <div class="name">银行业解决方案</div>
        <div class="sub">
          随着银行信息科技治理水平的提高，围绕科技创新探索更加合理的资源结构和成本结构，成为提高信息科技投入产出比加快科技创新推动产业升级的重要手段。 以离岸开发/测试为形态建设更加高效的低成本
        </div>
      </router-link>
      <router-link class="item" to="/solutionDetails2" target="_blank">
        <div class="pic"><img src="@/assets/img/solution/2.jpg"></div>
        <div class="name">企业金融解决方案</div>
        <div class="sub">
          橡诺科技凭借在集团财务公司行业多年的项目实施经验及专业知识积累，形成了一套完整的、科学的、有效的实施方法论，为客户提供丰富的业务咨询、业务系统建设及系统集成服务，相继服务于中油财务公司
        </div>
      </router-link>
      <router-link class="item" to="/solutionDetails3" target="_blank">
        <div class="pic"><img src="@/assets/img/solution/3.jpg"></div>
        <div class="name">保险行业解决方案</div>
        <div class="sub">橡诺科技财险业务系统基于客户中心理念设计，能够实现业务处理全过程管理，支持多级管理体系架构，支持集中控制、分散展业的业务处理模式，是一套支持财产保险公司业务处理的完美系统</div>
      </router-link>
      <router-link class="item" to="/solutionDetails4" target="_blank">
        <div class="pic"><img src="@/assets/img/solution/4.jpg"></div>
        <div class="name">地产行业解决方案</div>
        <div class="sub">橡诺地产工程质管解决方案以建筑工程质量管理体系理论为基础，立足于地产行业业务实践，实现了地产行业工程管理项目全生命周期质量动态管控。解决了地产行业因项目周期长、变化快</div>
      </router-link>
      <router-link class="item" to="/solutionDetails5" target="_blank">
        <div class="pic"><img src="@/assets/img/solution/5.jpg"></div>
        <div class="name">能源行业解决方案</div>
        <div class="sub">太阳能光伏发电项目随中国政府持续出台的支持光伏产业发展的政策不断增多。国家能源局发布消息称，截至2015年底，中国光伏发电累计装机容量4318万千瓦，成为全球光伏发电装机容量最大的国家</div>
      </router-link>
      <!-- <div class="item">
        <div class="pic"><img src="@/assets/img/solution/6.jpg"></div>
        <div class="name">汽车金融解决方案</div>
        <div class="sub">日前，限期清理整顿“首付贷”等违规互联网房地产金融业务，使更多平台往其他产业寻求资产端，汽车金融将是未来十年互联网金融的黄金十年</div>
      </div> -->
      <router-link class="item" to="/solutionDetails6" target="_blank">
        <div class="pic"><img src="@/assets/img/solution/7.jpg"></div>
        <div class="name">智能终端测试解决方案</div>
        <div class="sub">随着互联网+产业的蓬勃发展，智能终端的崛起，无论是移动终端制造商、移动通信运营商以及移动互联网内容服务商，都面临着新技术、新业务、新服务不断涌现，商用进程不断加快的局面</div>
      </router-link>
      <router-link class="item" to="/solutionDetails7" target="_blank">
        <div class="pic"><img src="@/assets/img/solution/8.jpg"></div>
        <div class="name">运营商大数据解决方案</div>
        <div class="sub">电信运营商作为固定电话、移动电话和互联网接入的通信服务机构，是天生的大数据企业，拥有超海量的数据规模（Volume），真实、实时、稳定的数据流（Velocity），复杂多样的数据类型</div>
      </router-link>
      <router-link class="item" to="/solutionDetails8" target="_blank">
        <div class="pic"><img src="@/assets/img/solution/9.jpg"></div>
        <div class="name">跨境电商解决方案</div>
        <div class="sub">近年以来，随着中国对跨境电子商务业务政策的逐步放开、物流供应链及支付体系等的不断完善、跨境电商消费者队伍的不断状大及中国传统制造业的不断加入，中国跨境电子商务蓬勃发展，所占进出口总</div>
      </router-link>
      <router-link class="item" to="/solutionDetails9" target="_blank">
        <div class="pic"><img src="@/assets/img/solution/10.jpg"></div>
        <div class="name">证券业解决方案</div>
        <div class="sub">证券业数据服务解决方案是面向证券行业客户提供的，针对各类交易数据进行采集、统计、分析、探查、预警、报告的专用解决方案。该方案提供了从基础信息到整合信息，从海量明细到宏观聚合的数据全流域综合管理</div>
      </router-link>
      <router-link class="item" to="/solutionDetails10" target="_blank">
        <div class="pic"><img src="@/assets/img/solution/11.jpg"></div>
        <div class="name">智慧医疗解决方案</div>
        <div class="sub">大数据助力解决地区“就医难” 患者作为医疗服务的需求方， 其就医选择直接影响着整个医疗卫生服务体系的运转和分级诊疗的实现。 橡诺科技帮助政府利用大数据技术和自身丰富的智慧城市建设运营经验</div>
      </router-link>
      <router-link class="item" to="/solutionDetails11" target="_blank">
        <div class="pic"><img src="@/assets/img/solution/12.jpg"></div>
        <div class="name">智慧康养解决方案</div>
        <div class="sub">伴随中国城乡居民在全生命周期健康管理、养老产业服务（含医养结合）领域日益增长的全面化、贯通化、个性化需要的发展过程，在中国养老领域的复杂社会背景下，橡诺科技始终致力于在健康养老领域的深耕</div>
      </router-link>
      <router-link class="item" to="/solutionDetails12" target="_blank">
        <div class="pic"><img src="@/assets/img/solution/13.jpg"></div>
        <div class="name">IT基础设施解决方案</div>
        <div class="sub">随着智慧业务的快速发展，越来越多的客户在考虑建设和优化IT基础设施以更好支撑上层智慧业务。 IT基础设施需要满足上层智慧业务对 数据的采集、通讯、转换、和整理以及应用和共享的需求。通过在</div>
      </router-link>
      <router-link class="item" to="/solutionDetails13" target="_blank">
        <div class="pic"><img src="@/assets/img/solution/14.jpg"></div>
        <div class="name">智慧物流解决方案</div>
        <div class="sub">目前我国大中城市普遍存在的商品流通“最后一公里”货车进城难、配送成本高、交通拥堵等问题；城市共同配送平台通过改善城市物流节点规划布局、科学确定零售网点卸货时间、加强城区货运车辆管理等措施</div>
      </router-link>
      <router-link class="item" to="/solutionDetails14" target="_blank">
        <div class="pic"><img src="@/assets/img/solution/15.jpg"></div>
        <div class="name">智慧农业解决方案</div>
        <div class="sub">橡诺科技智慧农业云平台以互联网+农业的新型模式，改变传统产业。以互联网为入口、分别从流通渠道，生产模式，营销模式的三个重要环节，为传统农业带来生产与市场与生产资源充分对接的机会</div>
      </router-link>
      <router-link class="item" to="/solutionDetails15" target="_blank">
        <div class="pic"><img src="@/assets/img/solution/16.jpg"></div>
        <div class="name">智慧社区解决方案</div>
        <div class="sub">“智慧社区”既是社区建设的一种思考理念，也是新形势下社区公共服务的一种新模式。“智慧社区”以智慧、人文、服务为理念，以“治理精细化、服务人文化、手段信息化、运营智慧化” 为建设思路，以统筹各类</div>
      </router-link>
    </div>
  </div>
  <Mission/>
</div>
</template>

<script>
import Mission from '@/components/Mission'
export default {
  name: '',
  components: {
    Mission
  }
}
</script>

<style scoped lang="less">
.service-content{
    width: 100%;
    overflow: visible;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    background-image: url(../assets/img/service-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .content{
      width: 1200px;
      overflow: visible;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      .title-name{
        height: 38px;
        color: #333333;
        transform: .5s;
        line-height: 38px;
        font-size: 30px;
        margin-top: 80px;
        margin-bottom: 18px;
        text-align: center;
        box-sizing: border-box;
      }
      .title-sub{
        width: 1039px;
        height: 48px;
        color: #666666;
        transform: .5s;
        line-height: 24px;
        text-align: center;
        font-size: 16px;
        box-sizing: border-box;
      }
      .list{
        margin-bottom: -20px;
        margin-top: 50px;
        width: 100%;
        display: -webkit-flex;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        box-sizing: border-box;
        .item{
          position: relative;
          width: 360px;
          margin-bottom: 50px;
          overflow: visible;
          display: flex;
          flex-direction: column;
          align-items: center;
          background-color: #FFFFFF;
          cursor: pointer;
          box-sizing: border-box;
          .pic{
            position: relative;
            box-sizing: border-box;
            img{
              width: 100%;
              vertical-align: middle;
            }
            &::before{
              position: absolute;
              content: '';
              top: 0;
              left: 0;
              bottom: 0;
              width: 100%;
              background-color: rgba(0,0,0,.5);
            }
          }
          .name{
            position: absolute;
            top: 80px;
            left: 0;
            width: 100%;
            color: #fff;
            font-weight: 600;
            font-size: 22px;
            text-align: center;
            box-sizing: border-box;
            z-index: 100;
          }
          .sub{
            position: absolute;
            top: 120px;
            left: 0;
            width: 100%;
            color: #fff;
            font-size: 14px;
            padding: 0 20px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            box-sizing: border-box;
          }
        }
        .two-item{
          width: 585px;
          height: 225px;
          .sub{
            width: 450px;
            height: 24px;
          }
        }
      }
    }
}
</style>
